import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { APP_ENV } from "app/constants/variables";
import UAParser from "ua-parser-js";

export async function getDeviceId() {
  const fpPromise = FingerprintJS.load();
  const fp = await fpPromise;

  const result = await fp.get();

  return result.visitorId;
}

export function getDeviceName() {
  const parser = new UAParser();
  const result = parser.getResult();

  const osAndBrowsername = result.os.name + " " + result.browser.name;
  return osAndBrowsername;
}

export const IS_IOS = navigator.userAgent.includes("iPhone") || navigator.userAgent.includes("iPad");
export const IS_ANDROID = navigator.userAgent.includes("Android");

export const getCheckoutDeepLink = (sourceId: string) => {
  if (APP_ENV === "production") {
    if (IS_IOS) {
      return `co.busha.apple://busha.co/checkout?checkoutId=${sourceId}`;
    }
    else if (IS_ANDROID) {
      return `co.busha.android://busha.co/checkout?checkoutId=${sourceId}`;
    }
  } else {
    if (IS_IOS) {
      return `co.busha.boro.development://busha.co/checkout?checkoutId=${sourceId}`;
    } else if (IS_ANDROID) {
      return `co.busha.android.development://busha.co/checkout?checkoutId=${sourceId}`;
    }
  }
}